import { useEffect, useState, useRef } from 'react';

export const DEFAULT_TIMEOUT_MS = 300;

export const useSliderVisibility = (
  showComponent: boolean,
  timeout = DEFAULT_TIMEOUT_MS,
): { visible: boolean; open: boolean; animating: boolean } => {
  const [visible, setVisible] = useState(showComponent);
  const [open, setOpen] = useState(showComponent);
  const [timeoutId, setTimeoutId] = useState<ReturnType<typeof setTimeout> | null>(null);
  const isMounted = useRef(false);

  useEffect((): undefined | (() => void) => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }

    if (timeoutId) clearTimeout(timeoutId);
    if (showComponent) {
      setVisible(true);
      setTimeoutId(
        setTimeout(() => {
          setOpen(true);
          setTimeoutId(setTimeout(() => setTimeoutId(null), timeout));
        }, 0),
      );
    }
    if (!showComponent) {
      setOpen(false);
      setTimeoutId(
        setTimeout(() => {
          setVisible(false);
          setTimeoutId(null);
        }, timeout),
      );
    }

    return () => timeoutId && clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showComponent, timeout]);

  return { visible, open, animating: Boolean(timeoutId) };
};
